import _ from '@lodash';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import OptimizationCaseService from 'app/admin/optimizationCase/service/OptimizationCaseService';
import { useWhatIf } from './WhatIfProvider';

function WhatIfOptimizationCaseSelect() {
	const { t } = useTranslation('optimizationCase');
	const { data, setData } = useWhatIf();

	const schema = yup.object().shape({
		optimizationCase: yup.number().nullable().required(t('validation:FIELD_REQUIRED'))
	});

	const methods = useForm({
		defaultValues: { optimizationCase: _.get(data, 'properties.optimizationCase', null) },
		mode: 'onChange',
		resolver: yupResolver(schema)
	});

	const handleChange = value => {
		if (!_.isUndefined(value))
			setData({
				...data,
				properties: {
					..._.get(data, 'properties', {}),
					...methods.getValues()
				}
			});
	};

	return (
		<FormProvider {...methods}>
			<div className="flex flex-row">
				<Controller
					control={methods.control}
					name="optimizationCase"
					render={({ field, fieldState }) => (
						<EditFormSelectField
							field={field}
							fieldState={fieldState}
							config={{ topic: 'whatIf' }}
							fieldConfig={{
								key: 'optimizationCase',
								text: 'Optimization Case',
								// type: 'enum',
								onChange: handleChange,
								items: () => OptimizationCaseService.getListSelection()
							}}
						/>
					)}
				/>
			</div>
		</FormProvider>
	);
}

export default WhatIfOptimizationCaseSelect;
